export enum SignalrPayloadEventId {
  Test = 1000,
  IScanLotStatusChanged,
}

export interface NotifyUserSignalrPayload {
  /**
   * The event identifier
   */
  readonly payloadEventId: SignalrPayloadEventId;
  readonly tenantId: string;
  readonly userId: number;
  readonly data: unknown | null;
}
